// M站全局板块
const mobileSearch = resolve =>
  require(['../../../views/mobilePublic/search'], resolve)
// 兑换码领取页
const getCode = resolve =>
  require(['../../../views/mobilePublic/getCode'], resolve)
// 兑换码兑换页
const redeemCode = resolve =>
  require(['../../../views/mobilePublic/redeemCode'], resolve)

const getOwnCode = resolve =>
  require(['../../../views/mobilePublic/getOwnCode'], resolve)

//咨询倾诉评价列表
const evaluateList = resolve =>
  require(['../../../views/evaluateList'], resolve)
// 咨询倾诉客服页
const customerService = resolve =>
  require(['../../../views/customerService'], resolve)

export default [
  {
    path: '/customer-service',
    component: customerService
  },
  {
    path: '/search',
    component: mobileSearch
  },
  {
    path: '/evaluate-list',
    component: evaluateList
  },
  {
    path: '/get-code/:codeId',
    component: getCode
  },
  {
    path: '/redeem-code',
    component: redeemCode
  },
  {
    path: '/get-own-code',
    component: getOwnCode
  }
]



// WEBPACK FOOTER //
// ./src/router/page/mobilePublic/index.js